var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ticket-view-main" },
    [
      _c("UserGuide"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content-left border-left-3" },
        [
          _c(
            "ul",
            { staticClass: "el-menu", attrs: { role: "menubar" } },
            [
              _vm._l(_vm.ticketViewList, function(item, key) {
                return [
                  _c(
                    "li",
                    {
                      key: item.id,
                      class: {
                        "el-menu-item": true,
                        "is-active": item.id == _vm.viewId
                      },
                      attrs: { role: "menuitem" },
                      on: {
                        click: function($event) {
                          return _vm.changeNav(item.id, key, $event)
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: { width: "70%" },
                          attrs: {
                            title:
                              "#" +
                              item.id +
                              " " +
                              item.name +
                              "(" +
                              item.description +
                              ")"
                          }
                        },
                        [_vm._v(_vm._s(item.name))]
                      ),
                      _vm._v(" "),
                      _c("ViewTicketCount", {
                        staticStyle: { width: "30%" },
                        attrs: { value: item }
                      })
                    ],
                    1
                  )
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-menu",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: "TICKET_MORE_VIEW_AUTH",
                  expression: "'TICKET_MORE_VIEW_AUTH'"
                }
              ],
              ref: "moreView",
              on: { close: _vm.onMenuClose, open: _vm.onMenuOpen }
            },
            [
              _c(
                "el-submenu",
                {
                  attrs: {
                    index: "1",
                    title: _vm.moreTicketViewDescriptionTitle
                  }
                },
                [
                  _c("template", { slot: "title" }, [
                    _c("span", { staticStyle: { color: "#D0D0D0" } }, [
                      _vm._v("更多视图")
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.otherTicketViewList, function(each) {
                    return _c(
                      "el-menu-item",
                      { key: each.id, attrs: { index: "1-" + each.id } },
                      [
                        [
                          _c(
                            "span",
                            {
                              staticStyle: { width: "65%" },
                              attrs: {
                                "data-id": each.id,
                                title:
                                  "#" +
                                  each.id +
                                  " " +
                                  each.name +
                                  "(" +
                                  each.description +
                                  ")"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.changeNav(each.id, null, $event)
                                }
                              }
                            },
                            [_vm._v(_vm._s(each.name))]
                          ),
                          _vm._v(" "),
                          _c("ViewTicketCount", {
                            staticStyle: { width: "30%" },
                            attrs: { value: each }
                          })
                        ]
                      ],
                      2
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content-right" },
        [
          _c("ViewTicketList", { ref: "ticketList" }),
          _vm._v(" "),
          _c("NewTicketDialog", { ref: "newTicketDialog" })
        ],
        1
      ),
      _vm._v(" "),
      _c("el-backtop", { attrs: { target: ".content-right", bottom: 140 } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a153766", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a153766","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketViewMain.vue
// module id = 1014
// module chunks = 75